// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bad3b201","239":"13529b4b","453":"804eff24","732":"5b8819bc"}[chunkId] + ".chunk.js";
};